import { render, staticRenderFns } from "./AccountContent.vue?vue&type=template&id=1bd78fa6&scoped=true&"
import script from "./AccountContent.vue?vue&type=script&lang=ts&"
export * from "./AccountContent.vue?vue&type=script&lang=ts&"
import style0 from "./AccountContent.vue?vue&type=style&index=0&id=1bd78fa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd78fa6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
